<template>
  <div class="pdf-parsing-settings mt-3">
    <h4>PDF-parsing instellingen</h4>
    <p class="text-muted">Beheer hoe de AI-PDF-parsing wachtrij zich gedraagt.</p>

    <div class="card">
      <div class="card-header">
        <i class="bi bi-sliders me-2"></i>Gelijktijdige verwerking
      </div>
      <div class="card-body">
        <div v-if="loading" class="text-center py-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Laden...</span>
          </div>
        </div>
        <form v-else @submit.prevent="save" class="row g-3 align-items-end">
          <div class="col-md-6">
            <label for="maxConcurrency" class="form-label">
              Maximaal aantal PDF's dat tegelijk geparsed wordt
            </label>
            <input
              type="number"
              class="form-control"
              id="maxConcurrency"
              v-model.number="value"
              :min="1"
              :max="max"
              required
            />
            <small class="text-muted">Een geheel getal tussen 1 en {{ max }}. Wijziging werkt direct door.</small>
          </div>
          <div class="col-md-3">
            <button type="submit" class="btn btn-primary w-100" :disabled="saving || !isValid">
              <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status"></span>
              <i v-else class="bi bi-check-lg me-1"></i>
              Opslaan
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="card mt-4">
      <div class="card-header">
        <i class="bi bi-info-circle me-2"></i>Uitleg
      </div>
      <div class="card-body">
        <p class="mb-0">
          Order-intakers kunnen meerdere PDF's tegelijk in de dropzone slepen. Ze worden in een
          gedeelde wachtrij geplaatst en na elkaar geparsed. Deze instelling bepaalt hoeveel PDF's
          er <strong>tegelijk</strong> verwerkt mogen worden. Een hogere waarde verwerkt grote drops
          sneller, maar belast de AI-service zwaarder.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceFactory from '../services/ServiceFactory';

export default {
  name: 'PdfParsingSettingsPage',
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appSettingsService: null,
      value: 2,
      max: 10,
      loading: false,
      saving: false,
    };
  },
  computed: {
    isValid() {
      return Number.isInteger(this.value) && this.value >= 1 && this.value <= this.max;
    },
  },
  created() {
    this.appSettingsService = ServiceFactory.getService('AppSettingsService');
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const result = await this.appSettingsService.getMaxConcurrency();
        if (result.success) {
          this.value = result.value;
          this.max = result.max;
        }
      } catch (error) {
        this.$emit('showToast', ['Fout bij laden van instelling', 'bg-danger']);
      } finally {
        this.loading = false;
      }
    },
    async save() {
      if (!this.isValid) return;
      this.saving = true;
      try {
        const result = await this.appSettingsService.setMaxConcurrency(this.value);
        if (result.success) {
          this.value = result.value;
          this.$emit('showToast', ['Instelling opgeslagen', 'bg-success']);
        }
      } catch (error) {
        const message = error.response?.data?.message || 'Fout bij opslaan van instelling';
        this.$emit('showToast', [message, 'bg-danger']);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.pdf-parsing-settings {
  max-width: 900px;
}
</style>
